import { render, staticRenderFns } from "./ChildrensChoir.vue?vue&type=template&id=69b03400&"
import script from "./ChildrensChoir.vue?vue&type=script&lang=js&"
export * from "./ChildrensChoir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports